import { useCpmsBoGetTransactionReportsCountByConnectorTypeQuery } from '@service/cpms-bo-transaction-reports-count-statistics.service';

import {
  ByConnectorTypeCard,
  ByConnectorTypeCardVariantEnum,
} from '../../components/by-connector-type-card/by-connector-type.card';
import { useFilters } from '../../context/filters.context';

export const TransactionsByConnectorTypeCard = (): React.JSX.Element => {
  const { transformedFilters } = useFilters();
  const { data } = useCpmsBoGetTransactionReportsCountByConnectorTypeQuery({
    ...transformedFilters,
  });

  return (
    <ByConnectorTypeCard
      data={data}
      variant={ByConnectorTypeCardVariantEnum.Transactions}
    />
  );
};
